<template>
    <div class="table-responsive">
        <div class="table-outer">
            <table class="table-style2">
                <thead>
                    <tr class="business-qualifications-header-table">
                        <th v-for="(header, headerId) in tableHeaders"
                            :key="headerId">
                            <p>{{ header }}</p>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in tableRows"
                        class="row-items">
                        <td>
                            {{ row.date }}
                        </td>
                        <td>
                            ${{ money.format(row.value, 'fnd') }}
                        </td>
                        <td>
                            <button class="button--primary"
                                    v-if="IsGenerateButtonVisible(row.invoice_generated_id)"
                                    :disabled="!isVerified()"
                                    @click="GenerateInvoice(row.id)"
                                    :class="{ 'button--progress': IsInvoiceGenerating(row.id) }">Generate</button>
                            <a class="button--primary"
                                    v-if="!IsGenerateButtonVisible(row.invoice_generated_id)"
                                    :href="GetDownloadLink(row.invoice_generated_id)">Download</a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        dependencies: ['invoice', 'money'],
        data () {
            return {
                tableHeaders: {
                    date: 'Date',
                    value: 'Value',
                    invoice: 'Invoice'
                },
                generatingQueue: []
            }
        },
        computed: {
            tableRows () {
                return this.$store.getters.packages;
            }
        },
        methods: {
            isVerified () {
                return this.$store.getters.user.isVerified;
            },
            IsGenerateButtonVisible (invoiceId) {
                return !invoiceId;
            },
            GenerateInvoice (packageId) {
                this.$store.commit('addPackageToQueue', packageId);
                this.invoice.generateInvoice(packageId);
            },
            IsInvoiceGenerating (packageId) {
                return this.$store.getters.getGeneratingQueue.indexOf(packageId) > -1;
            },
            GetDownloadLink (invoiceId) {
                return this.invoice.getDownloadLink(invoiceId);
            }
        }
    }
</script>

<style>
    th,
    th p{
        cursor: default;
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/invoices/InvoicesTable.vue